import { render, staticRenderFns } from "./button-group-yes-only.vue?vue&type=template&id=51730dee&scoped=true"
import script from "./button-group-yes-only.vue?vue&type=script&lang=js"
export * from "./button-group-yes-only.vue?vue&type=script&lang=js"
import style0 from "./button-group-yes-only.vue?vue&type=style&index=0&id=51730dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51730dee",
  null
  
)

export default component.exports